import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { DropDown, IDropDownOption } from "../dropdown/Dropdown";

const useStyles = makeStyles({
  root: {
    width: "100%",
    margin: "7px 0px",
  },
  labelContainer: {
    display: "flex",
    padding: "7px 0",
    gap: "8px",
  },
  label: {
    fontSize: "14px",
    lineHeight: "21px",
    color: "#464B52",
  },
  required: {
    color: "#DA212C",
    height: "16px",
  }
});

interface DropDownContainerProps {
  placeholder: string;
  label?: string;
  required?: boolean;
  defaultSelectorValue: IDropDownOption;
  disabled?: boolean;
  options: IDropDownOption[];
  handleOnSelect: (value: string) => void;
}

export const DropDownContainer: React.FC<DropDownContainerProps> = ({
  placeholder,
  required,
  label,
  defaultSelectorValue,
  handleOnSelect,
  disabled,
  options
}) => {


  const classes = useStyles();

  return (
    <div style={{ fontWeight: 400 }} className={classes.root}>
       {label && <div className={classes.labelContainer}>
        <label className={classes.label}>{label}</label>
        {required && (
          <div style={{ fontWeight: 600 }} className={classes.required}>
            *
          </div>
        )}
      </div>}

        <DropDown
          options={options}
          handleOnSelect={handleOnSelect}
          defaultSelectorValue={defaultSelectorValue}
          disabled={disabled || false}
        />
    </div>
  );
};
